import { Navigate, Route, Routes } from "react-router-dom";
import { Suspense } from "react";
import Home from "../containers/home";
import Users from "../containers/users";
import Messages from "@/containers/messages";
import Tests from "@/containers/tests";
import TestDetail from "@/containers/test-detail";
import Login from "@/containers/login";
import AcceptInvitation from "@/containers/accept-invitation";
import Questionnaire from "@/containers/questionnaire";
import QuestionnaireDetail from "@/containers/questionnaire-detail";

const PageRoutes = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/home" element={<Home />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/users" element={<Users />} />
        <Route path="/tests" element={<Tests />} />
        <Route path="/test/:id" element={<TestDetail />} />
        <Route path="/login" element={<Login />} />
        <Route path="/accept-invitation" element={<AcceptInvitation />} />
        <Route path="/questionnaire" element={<Questionnaire />} />
        <Route path="/questionnaire/:id" element={<QuestionnaireDetail />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
};

export default PageRoutes;
